<div
  leaflet
  [leafletOptions]="options"
  [leafletLayersControl]="layersControl"
  [leafletFitBounds]="fitBoundsOptions"
  [leafletMarkerCluster]="markerClusterData"
  (leafletClick)="createMarker($event.latlng)"
></div>
